import React, { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { importTheme, exportTheme } from '../api/themeApi';

/**
 * Theme component for importing and exporting theme packages
 */
const Theme = () => {
  const [alertState, setAlertState] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  // Handle file selection
  const handleFileSelect = (event) => {
    if (event.target.files && event.target.files[0]) {
      handleImportTheme(event.target.files[0]);
    }
  };

  // Handle theme import
  const handleImportTheme = async (file) => {
    try {
      const response = await importTheme(file);
      if (response.status === 'success') {
        setAlertState({
          open: true,
          message:
            'Successfully imported theme file to Sandbox snapshot.  Imported assets will need to be published before they will be made live.',
          severity: 'success',
        });
      } else {
        throw new Error(response.status || 'Failed to import theme');
      }
    } catch (error) {
      setAlertState({
        open: true,
        message: `Error importing theme: ${error.message}`,
        severity: 'error',
      });
    }
  };

  // Handle theme export
  const handleExportTheme = async () => {
    try {
      const response = await exportTheme();
      if (response.status === 'success' && response.packageDownloadUrl) {
        window.location.href = response.packageDownloadUrl;
        setAlertState({
          open: true,
          message: 'Theme exported successfully',
          severity: 'success',
        });
      } else {
        throw new Error('Failed to export theme');
      }
    } catch (error) {
      setAlertState({
        open: true,
        message: `Error exporting theme: ${error.message}`,
        severity: 'error',
      });
    }
  };

  // Handle alert close
  const handleAlertClose = () => {
    setAlertState({
      ...alertState,
      open: false,
    });
  };

  return (
    <div>
      <div className="header row">
        <h1 className="page-title">Manage Theme</h1>
      </div>
      <div className="module red row calendar-list">
        <div className="module-header">
          <span className="module-title subtitle">Import/Export Theme</span>
        </div>
        <div className="col-xs-12 no-left-padding">
          <div className="module-body" style={{ paddingBottom: '20px' }}>
            <div id="importExportGrowl">
              <Snackbar
                open={alertState.open}
                autoHideDuration={6000}
                onClose={handleAlertClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert onClose={handleAlertClose} severity={alertState.severity}>
                  {alertState.message}
                </Alert>
              </Snackbar>
            </div>
            <form name="importExportThemeForm" role="form">
              <div className="row border-top border-bottom content">
                <div className="col-sm-12 no-left-padding">
                  <label
                    htmlFor="theme-package-upload"
                    className="btn btn-primary"
                    id="titleImageFile"
                  >
                    Import Theme
                    <input
                      id="theme-package-upload"
                      type="file"
                      accept="application/zip"
                      onChange={handleFileSelect}
                      style={{ display: 'none' }}
                    />
                  </label>{' '}
                  <button type="button" onClick={handleExportTheme} className="btn btn-primary">
                    Export Theme
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Theme;
